import SumoLogger from 'sumo-logger';
import {
  endpoint,
  sourceName,
} from 'shared/logger/config/sumoLogicBaseConfig';
import { debugLog } from 'shared/logger/debugLog';

const SUMO_QUOTA_COOLDOWN_MS = 3 * 60 * 60 * 1000;

let sumoQuotaSilencedUntil = 0;

function onSumoTransportError(): void {
  const error = arguments[0];
  const now = Date.now();

  if (now < sumoQuotaSilencedUntil) {
    return;
  }

  if (isSumoQuotaExceededError(error)) {
    sumoQuotaSilencedUntil = now + SUMO_QUOTA_COOLDOWN_MS;
    debugLog(
      '[sumo-logger] quota exceeded, silencing transport errors until',
      new Date(sumoQuotaSilencedUntil).toISOString()
    );
    return;
  }

  debugLog('[sumo-logger] transport error', error);
}

function isSumoQuotaExceededError(error: unknown): boolean {
  const candidate = error as {
    status?: number;
    response?: { status?: number };
    message?: string;
  };

  if (candidate?.status === 429 || candidate?.response?.status === 429) {
    return true;
  }

  const message = String(candidate?.message ?? '').toLowerCase();
  const contains429 = message.includes('429');
  const containsQuotaContext =
    message.includes('sumo') || message.includes('quota');

  return contains429 && containsQuotaContext;
}

export const appSumoLogicLogger = new SumoLogger({
  sourceName,
  endpoint,
  sendErrors: true,
  sourceCategory: 'React app',
  onError: onSumoTransportError,
});
